<template>
  <div class="video-section pb-0 pb-md-5">
    <div class="bg-mint">
      <b-row align-h="start" no-gutters>
        <b-col lg="3" class="d-none d-lg-block header-arrow-image" align-self="center">
          <b-img fluid :src="arrowImage" />
        </b-col>
        <b-col cols="12" lg="6" class="text-center my-5 font-responsive">
          <b-img :src="handIconImage" />
          <p class="h2 font-weight-bold font-italic mx-2 mt-4 mb-0">
            {{ $t('home.bottomSection.videoHeader') }}
          </p>
        </b-col>
      </b-row>
    </div>
    <div id="embed-video" class="position-relative">
      <b-embed type="iframe" :src="youtubeSrc" allowfullscreen id="movie" class="position-absolute">
      </b-embed>
      <div class="position-absolute bottomSection-play" @click="play()" id="customPlayButton">
        <b-icon-play-circle-fill
          variant="white"
          class="rounded-circle bg-blue-500"
          font-scale="4.7"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const youtubeSrc = ref<string>('https://www.youtube.com/embed/GrBgLcUXvxs')

const play = (): void => {
  const movieElement = document.getElementById('movie')
  const customPlayButton = document.getElementById('customPlayButton')
  if (movieElement) {
    movieElement.setAttribute('src', youtubeSrc.value.concat('?autoplay=1'))
  }
  if (customPlayButton) {
    customPlayButton.style.display = 'none'
  }
}

const arrowImage = new URL('/src/assets/images/arrow.png', import.meta.url).href

const handIconImage = new URL('/src/assets/images/hand_icon.png', import.meta.url).href
</script>

<style scoped>
.header-arrow-image {
  max-height: 200px;
  margin-top: -50px;
}
</style>
